import { useQuery } from "@tanstack/react-query"
import { getPitchbookCompany } from "@/api"
import { PitchbookCompanyData } from "@/types"

export const usePitchbookCompany = (companyId?: number) => {
  const query = useQuery<PitchbookCompanyData>({
    queryKey: ["pitchbook", companyId],
    queryFn: () => getPitchbookCompany(companyId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!companyId,
  })

  return {
    ...query,
    data: query.data || null,
  }
}
